// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import dotsGridIcon from "@/assets/icons/dots-grid.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type DotsGridIconProps = Omit<IconProps, "name">;

export function DotsGridIcon(props: DotsGridIconProps): React.ReactNode {
  return <Icon name={dotsGridIcon} {...props} />;
}
